export default {
  email: 'E-mail',
  surname: 'Surname',
  phone: 'Phone Number',
  password: 'Password', // User interface label for password input
  passwordEntry: 'Password', // User interface label for password entry
  confirmPassword: 'Confirm Password', // User interface label for confirming password
  view: 'View',
  edit: 'Edit',
  add: 'Add',
  reload: 'Reload',
  download: 'Download',
  downloadAll: 'Download All',
  downloadFile: 'Download File',
  filters: 'Filters',
  thereIsNoFileExist: 'There is no file exist.',
  fileExist: 'File Exist',
  delete: 'Delete',
  remove: 'Remove',
  save: 'Save',
  saveAndNext: 'Save and Next',
  logOut: 'Log Out',
  showDetail: 'Show Detail',
  operations: 'Operations',
  totalRecord: 'Total Record',
  slots: 'Slots',
  city: 'City',
  selectCity: 'Select city.',
  country: 'Country',
  selectCountry: 'Select country.',
  cityCode: 'City Code',
  geocodingApiType: 'Geocoding API',
  selectGeocoding: 'Select geocoding api.',
  matrixType: 'Matrix Type',
  selectMatrixType: 'Select matrix type.',
  isActive: 'Is Active?',
  warehouseCode: 'Warehouse Code',
  warehouseName: 'Warehouse Name',
  lat: 'Latitude',
  lon: 'Longitude',
  parameterName: 'Parameter Name',
  parameterMappingCode: 'Parameter Mapping Code',
  parameterType: 'Parameter Type',
  selectParameterType: 'Select parameter type',
  value: 'Value',
  isMainParameter: 'Is Main Parameter?',
  zone: 'Zone',
  selectZone: 'Select zone.',
  flatDeliveryFee: 'Flat Delivery Fee',
  selectProfile: 'Select profile.',
  mainParameterName: 'Main Parameter Name',
  selectMainParameter: 'Select main parameter.',
  showParameter: 'Show Parameter',
  modalDeleteTitle: 'Are You Sure?',
  citiesServedDelete: 'Selected city will be deactivated',
  yes: 'Yes',
  cancel: 'Cancel',
  processCompleted: 'Process Completed',
  deletedCitiesServed: 'Selected city is deactivated.',
  addedCitiesServed: 'City served added.',
  editedCitiesServed: 'City served edited',
  parameterCategory: 'Paremeter Category',
  defaultValue: 'Default Value',
  parameterGroup: 'Parameter Group',
  parameterExistence: 'Parameter Existence',
  addParametersDetail: 'Add Parameter Detail',
  parametersDetailDeleteConfirm: 'Selected parameter will be deactivated.',
  parametersDetailDeleted: 'Selected parameter is deactivated.',
  addedParametersDetail: 'Parameter detail added.',
  editParametersDetail: 'Edit Parameter Detail',
  ParametersDetailUpdated: 'Parameter detail updated.',
  selectParameterCategory: 'Select parameter category.',
  addedRoutingParameter: 'Routing parameter added.',
  editedRoutingParameter: 'Routing parameter edited.',
  deletedRoutingParameter: 'Routing parameter deleted.',
  parameterValueCompleted: 'Routing parameter values saved',
  addedNewPolygon: 'New Polygon added.',
  updatedNewPolygon: 'Polygon updated.',
  polygonWillDelete: 'Selected polygon will be deactivated.',
  polygonDeleted: 'Selected polygon is deactivated.',
  selectPolygon: 'Select polygon.',
  polygonSummary: 'Order Summary',
  addPolygon: 'Add Polygon',
  polygonName: 'Polygon Adı',
  editPolygon: 'Edit Polygon',
  showAllStores: 'Show All Stores',
  hideAllStores: 'Hide All Stores',
  storeEcomStatus: 'Store Ecom Status',
  m2Info: 'M² Info',
  minCannotBeGreaterThanMax: 'Min cannot be greater than max!',
  maxCannotBeLessThanMin: 'Max cannot be less than min!',
  showZones: 'Show Zones',
  zones: 'Zones',
  zoneName: 'Zone Name',
  storeWhereDelivered: 'Store Where Delivered',
  courierIdentityNumber: 'Courier Identity Number',
  courierPhoneNumber: 'Courier Phone Number',
  directorate: 'Directorate',
  maxWeeksAllowed: 'Max Weeks Allowed',
  DELETED: 'Deleted',
  showOnForm: 'Show Parameter',
  monitoring: 'Route Monitoring',
  courierName: 'Courier Name',
  courierSource: 'Courier Source',
  courierSources: 'Courier Sources',
  courierCode: 'Registration Number',
  visitOrderNo: 'Queue',
  orderId: 'Order Number',
  customerName: 'Customer Name',
  address: 'Address',
  username: 'Username',
  usernameEntry: 'Username',
  loginError: 'Username or password is incorrect',
  citiesServedAdd: 'City Served Add',
  citiesServedEdit: 'City Served Edit',
  parameterAdd: 'Parameter Add',
  parameterEdit: 'Parametre Edit',
  slotId: 'Slot ID',
  slotLastOrderTime: 'Last Order Time',
  slotBeginTime: 'Begin Time',
  slotEndTime: 'End Time',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  deliveryFee: 'Delivery Fee',
  zoneId: 'Zone Id',
  minimumCartAmount: 'Minimum Cart Amount',
  maximumCartAmount: 'Maximum Cart Amount',
  addedCourier: 'Courier added.',
  addedTaskGroup: 'Store Schedule added.',
  addTaskPlan: 'New Store Schedule',
  actions: 'Actions',
  actionName: 'Action Name',
  isRequired: 'Is Required',
  actionError: 'Action Error',
  editTaskPlan: 'Edit Store Schedule',
  schedule: 'Schedule',
  ecommerceTask: 'E-Commerce Store Task',
  taskPriority: 'Task Priority',
  addTaskGroup: 'Add Task Group',
  taskOpening: 'Task Opening',
  taskClosing: 'Task Closing',
  freeTimeSelection: 'Free Time Selection',
  editTaskGroup: 'Edit Task Group',
  addedTaskPlan: 'Store Schedule added.',
  taskPlanUpdated: 'Store Schedule updated.',
  addedTaskGroup: 'Task Group added.',
  taskGroupUpdated: 'Task Group updated.',
  addedTaskTemplate: 'Task added.',
  taskTemplateUpdated: 'Task updated.',
  taskPlanDeleted: 'Store Schedule deleted.',
  taskGroupDeleted: 'Task Group deleted.',
  taskTemplateDeleted: 'Task deleted.',
  scheduleTemplateName: 'Schedule Template Name',
  addTaskTemplates: 'Add Task Templates',
  taskGroupName: 'Task Group Name',
  taskTemplateName: 'Task Template Name',
  taskPeriod: 'Task Period',
  taskOrder: 'Task Order',
  taskDesc: 'Task Description',
  source: 'Source',
  openingAndClosingTime: 'Opening and Closing Time',
  openingTime: 'Opening Time',
  closingTime: 'Closing Time',
  taskWithDayAndMonth: 'Task with Day and Month',
  weekDaysCombination: 'Week Days Combination',
  daysOfMonth: 'Days of Month',
  dayChoose: 'Day Choose',
  frequency: 'Frequency',
  errorMessageSamePriority: 'There is already a task with the same priority!',
  editTaskTemplate: 'Edit Task Template',
  endDateMustBeAfterStartDate: 'End date must be after start date',
  relationTime: 'Relation Time',
  taskDuration: 'Task Duration',
  taskPlanDeleteConfirm: 'selected task plan will be deactivated.',
  taskGroupDeleteConfirm: 'selected task group will be deactivated.',
  deliveryCode: 'Delivery Code',
  orderCourierManagementDeleteConfirm: 'Selected order will be deactivated.',
  orderCourierManagementDeleted: 'Selected order is deactivated.',
  addOrderCourierManagement: 'Add Order Courier Management',
  addedOrderCourierManagement: 'Order Courier Management added.',
  editOrderCourierManagement: 'Edit Order Courier Management',
  orderCourierManagementUpdated: 'Order Courier Management updated.',
  courierAdd: 'Courier Add',
  fullName: 'Name Surname',
  phoneNumber: 'Phone Number',
  identityNumber: 'TR Identity Number ',
  tcknVkn: 'TCKN/VKN',
  tcknVknErrMessage: 'TCKN/VKN must be 11/10 characters',
  tcknErrMessage: 'TCKN must be 11 characters',
  idNumberToBeInvoiced: 'ID Number to be Invoiced',
  birthDate: 'Birth Date',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  courierApplicationsDetail: 'Tradesman Courier Application Details',
  hasYes: 'Yes',
  hasNo: 'No',
  p1AuthorizationCertificate: 'P1 Authorization Certificate',
  soleProprietorship: 'Sole Proprietorship',
  regionsToBeServed: 'Regions To Be Served',
  salaryExpectation: 'Salary Expectation',
  contractApprovalPermission: 'Contract Approval Permission',
  applicationDate: 'Application Date',
  color: 'Color',
  editedCourier: 'Courier edited.',
  courierEdit: 'Courier Edit',
  id: 'Id',
  courierStatus: 'Courier Status',
  CouriersAwaitingDetail: 'Couriers Awaiting Approval Detail',
  CouriersAwaitingDetailUpdated: 'Couriers Awaiting Detail Updated',
  MOTORCYCLE: 'Motorcycle',
  COMMERCIAL_VEHICLE: 'Commercial Vehicle',
  PASSENGER_VEHICLE: 'Passenger Vehicle',
  createdTime: 'Created Time',
  courierDelete: 'Selected courier will be deactivated.',
  courierActive: 'Selected courier will be activated.',
  deletedCourier: 'Selected courier is deactivated.',
  addedVehicleGroup: 'Vehicle group added.',
  vehicleGroupActive: 'Selected vehicle group will be activated.',
  vehicleGroupStatusChanged: 'Vehicle group status changed.',
  vehicleGroupEdited: 'Vehicle group edited.',
  vehicleGroup: 'Vehicle Group',
  vehicleGroupAdd: 'Vehicle Group Add',
  capacityInfo: 'Capacity Informations',
  capacityKg: 'Capacity (KG)',
  capacityQuantity: 'Capacity (Piece)',
  capacityCc: 'Capacity (CC)',
  costInfo: 'Cost Informations',
  fixedCost: 'Fixed Cost',
  changingCost: 'Changing Cost',
  transportationCost: 'Transportation Cost',
  waitingCost: 'Waiting Cost',
  workInfo: 'Working Informations',
  workBeginTime: 'Working Begin Time',
  workBeginTimePlaceHolder: 'Select work start time..',
  workEndTime: 'Work End Time',
  workEndTimePlaceHolder: 'Select work end time..',
  breakBeginTime: 'Break Begin Time',
  breakBeginTimePlaceHolder: 'Select break start time..',
  breakEndTime: 'Break End Time',
  breakEndTimePlaceHolder: 'Select break end time..',
  breakDuration: 'Break Duration',
  freeDay: 'Free Day',
  maximumDailyDistance: 'Maximum Daily Distance',
  averageLoadDuration: 'Average Load Duration',
  editedVehicleGroup: 'Vehicle group edited.',
  vehicleGroupEdit: 'Vehicle Group Edit',
  vehicleGroupDelete: 'Selected vehicle group will be deactivated.',
  deletedVehicleGroup: 'Selected vehicle group is deactivated.',
  vehicleAdd: 'Vehicle Add',
  vehicleInfo: 'Vehicle Informations',
  plateNumber: 'Plate Number',
  vehiclePlateInfo: 'Vehicle Plate Information',
  vehicleBrand: 'Brand',
  vehicleModel: 'Model',
  year: 'Year',
  warehouse: 'Warehouse',
  lastCourier: 'Last Courier',
  vehicleStatus: 'Status',
  vehicleEdit: 'Vehicle Edit',
  vehicleType: 'Vehicle Type',
  vehicleDelete: 'Selected vehicle will be deactivated.',
  vehicleActive: 'Selected vehicle will be activated.',
  vehicleStatusChanged: 'Vehicle status changed.',
  deletedVehicle: 'Selected vehicle is deactivated.',
  logoUniqueCode: 'Product Code',
  productName: 'Product Name',
  quantity: 'Quantity',
  no: 'No',
  newShipment: 'New Shipment',
  courierStartEndTime: 'Courier Work Starting and Ending Methods',
  packaging: 'Started to Collect',
  waitingForCourier: 'Collection Complete',
  inTransit: 'In Transit',
  delivered: 'Delivered',
  replaced: 'Slot Changed',
  orderDetail: 'Order Detail',
  generalInfo: 'General Informations',
  orderCreatedTime: 'Created Time',
  deliveryDate: 'Delivery Date',
  storeId: 'Warehouse',
  elite: 'Elite',
  frozen: 'Frozen',
  amountInfo: 'Amount Informations',
  amountInformation: 'Amount Information',
  price: 'Price',
  totalDiscount: 'Total Discount',
  totalRefunded: 'Total Refunded',
  totalRefundedAmount: 'Total Refunded Amount',
  totalPaid: 'Total Paid',
  otherInfo: 'Other Informations',
  shipmentStatus: 'Shipment Status',
  slotTime: 'Slot',
  platform: 'Platfom',
  orderItems: 'Ordered Products',
  orderItemInformation: 'Ordered Products Information',
  addressInfo: 'Address Informations',
  updateAddress: 'Update Address',
  addressPlaceholder: 'Enter Address..',
  orderDelete: 'Selected order will be deactivated.',
  deletedOrder: 'Selected order is deactivated.',
  neighborhood: 'Neighborhood',
  route: 'Route',
  analyze: 'Analyze',
  applyRoute: 'Apply Route',
  approve: 'Approve',
  reject: 'Reject',
  sendToFinanceApproval: 'Send To Finance Approval',
  selectAll: 'Select All',
  lateDuration: 'Late Duration',
  searchCourierPlaceholder: 'Courier search..',
  distance: 'Distance',
  km: 'km',
  time: 'Time',
  min: 'min',
  vehicle: 'Vehicle',
  totalVehicle: 'Total Vehicle',
  listCourierCount: 'Total Courier Listed: ',
  planned: 'Planned',
  unplanned: 'Unplanned',
  total: 'Total',
  ordersTotal: 'Total Orders',
  totalExpediton: 'Expediton',
  listOrderCount: 'Total Order Listed: ',
  taskId: 'Task ID',
  solverStatus: 'Task Statu',
  taskStartTime: 'Task Start Time',
  taskEndTime: 'Task End Time',
  completed: 'Completed',
  continues: 'Continues',
  failed: 'Failed',
  orangeColorCode: '#f58634',
  redColorCode: '#F32B00',
  greenColorCode: '#52c41a',
  uncompleted: 'Uncompleted',
  completedValue: 'COMPLETED',
  unsolvedValue: 'UNSOLVED',
  taskfailedValue: 'Task failed',
  routingErrorContent:
    'An error occurred while routing. Please try to routing again.',
  tour: 'Help',
  estimatedArrivalTime: 'Estimated Arrival Time',
  actualArrivalTime: 'Actual Arrival Time',
  cancelled: 'Cancelled',
  companyName: 'Company',
  roles: 'Roles',
  distributionCenters: 'Defined Distribution Centers',
  editedUser: 'User edited.',
  userDelete: 'Selected users is deactivated.',
  colorAdd: 'Add Color',
  addedColor: 'New color added.',
  chooseColor: 'Please choose color.',
  required: 'Required field!',
  info: 'Info',
  liveFeedNoDataError:
    'The live tracking data of the order you are looking for could not be found.',
  realExitTimeFromDistributionCenter: 'Real Exit Time From Distribution Center',
  estimatedFirstOrderDeliveryTime: 'Estimated First Order Delivery Date',
  realFirstOrderDeliveryTime: 'Real First Order Delivery Date',
  estimatedReturnTime: 'Estimated Return Time',
  realReturnTime: 'Real Return Time',
  reRoute: 'Re Route',
  reRoutingModalMessage:
    'The rerouting process has been started. Your routing result will be automatically confirmed. Do not close this page until the routing process is completed.',
  reRoutingInformationMessage:
    'After this process, rerouting is required to reflect the courier change. After completing the process, you can perform this operation by using the reroute button.',
  warning: 'Warning',
  paymentType: 'Payment Type',
  name: 'Name',
  firmName: 'firmName',
  stores: 'Stores',
  store: 'Store',
  activeStore: 'Active Store',
  firms: 'Firms',
  firmAdd: 'Add Firm',
  firmEdit: 'Edit Firm',
  firmDeleted: 'Firm deleted',
  firmDelete: 'Firm delete',
  chooseFirm: 'Choose Firm',
  addedFirm: 'Firm added',
  editedFirm: 'Firm edited',
  userInfo: 'User Info',
  addRole: 'Add Role',
  addNewRole: 'Add New Role',
  addImage: 'Add Image',
  deleteRole: 'Delete Role',
  firm: 'Firm',
  firmCurrent: 'Firm Current',
  courierType: 'Courier Type',
  createdAt: 'Created At',
  createdByCourier: 'Created Courier By User',
  definedAnyRole: 'You have not defined any roles!',
  activeStoreNotInDefinedStores:
    'Active store does not exist inside user stores!',
  vehicles: 'Vehicles',
  chooseVehicleGroup: 'Choose Vehicle Group',
  chooseVehicleModel: 'Choose Vehicle Model',
  vehicleDeleted: 'Vehicle deleted!',
  addedVehicle: 'Vehicle added!',
  editedVehicle: 'Vehicle edited!',
  courierType_STAFF: 'Staff',
  courierType_TRADESMAN: 'Tradesman',
  isActive_true: 'Aktif',
  isActive_false: 'Pasif',
  userDeleted: 'User deleted!',
  addUser: 'Add User',
  editUser: 'Edit User',
  regions: 'Regions',
  region: 'Region',
  administrativeRegion: 'Administrative Region',
  regionDelete: 'Region Delete',
  regionDeleted: 'Region Deleted!',
  addedRegion: 'Region Added!',
  editedRegion: 'Region Edited!',
  activeRegion: 'Active Region',
  regionAdd: 'Add Region',
  regionEdit: 'Edit Region',
  addedUser: 'User Added!',
  currencyAccount: 'Currency Account',
  sendLink: 'Send Link',
  chooseStore: 'Choose Store',
  sentLink: 'Link sent.',
  userNotCollectorOrCourier: 'This user is not a courier or a collector!',
  role: 'Role',
  courier: 'Courier',
  collector: 'Collector',
  changeCourier: 'Change Courier',
  courierChanged: 'Courier changed.',
  usersSentLinks: 'Users Sent Links',
  orderNo: 'Order No',
  statusOfTheOrderIsNotSuitableForChangingTheCourier:
    'Status Of The Order Is Not Suitable For Changing The Courier',
  requiredStore: 'Required Store!',
  regionName: 'Region Name',
  regionCode: 'Region Code',
  active: 'Active',
  passive: 'Passive',
  activate: 'Activate',
  userActivate: 'The selected user will be activated',
  selectStore: 'Select Store',
  applicability: 'Applicability',
  allStoresApplicability: 'Applicable to All Stores',
  specificStoresApplicability: 'Applicable to Specific Stores',
  regionalManager: 'Regional Manager',
  regionalManagerPhoneNum: 'Regional Manager Phone Number',
  regionId: 'Region ID',
  selectRegion: 'Select Region',
  selectActiveStoreOrRegion: 'Select Active Store/Region',
  selectRole: 'Select Role',
  selectStoreOrRegion: 'Select Store/Region',
  enterPassword: 'Please enter password',
  ORDER_ZONE: 'Order Zone',
  STORE_ZONE: 'Store Zone',
  RED_ZONE: 'Red Zone',
  ACTIVE: 'ACTIVE',
  PASSIVE: 'PASSIVE',
  versionApprovalStatus: 'Version Approval Status',
  true: 'True',
  false: 'False',
  enterLocation: 'Enter the location (29.101,32.335)',
  locationWarningMessage:
    'Please enter in the correct format. Ex: 40.234,29.33',
  modalConfirm: 'Are you sure?',
  sendConfirmZone: 'Are you sure you want to submit it for approval?',
  heatmap: 'Heatmap',
  totalOrders: 'Total Orders',
  onTimeOrders: 'On Time Orders',
  cancelledOrders: 'Cancelled Orders',
  notOnTimeOrders: 'Not On Time Orders',
  returnedOrders: 'Returned Orders',
  notReturnedOrders: 'Not Returned Orders',
  storeDetails: 'Store Details',
  heatmapSettings: 'Map Settings',
  includeDeliveryFromStore: 'Include Delivery From Store',
  dateRangeForHeatmap: 'Date Range for Heatmap',
  dateRangeForOrder: 'Date Range for Order',
  show: 'Show',
  showClusteredMarkers: 'Show Clustered Markers',
  zoneCode: 'Zone Code',
  zoneName: 'Zone Name',
  areaKm: 'Area(km²)',
  storeCode: 'Store Code',
  slotDayCount: 'Slot Day Count',
  slotDayCountRange: 'Slot day count must be between 1 and 9.',
  isOvenAvailable: 'Is Oven Available',
  areaM2: 'Area (M²)',
  mainZoneMinimumCartAmount: 'Main Zone Min. Cart Amount',
  storeZoneDeliveryFees: 'Delivery Fee Tiers',
  deliveryFeeInfo: 'Delivery Fee Info',
  storeName: 'Store Name',
  storeStatus: 'Store Status',
  storeNumber: 'Store Number',
  storePhoneNumber: 'Store Phone Number',
  storeNumber2: 'Store Number 2',
  storeEdit: 'Store Edit',
  cityName: 'City Name',
  districtName: 'District Name',
  maxCharacterExceed:
    'You have exceeded the maximum number of characters (max 80 character)!',
  passwordLength: 'Password must be at least 8 characters long', // Validation message, not a hardcoded credential
  pricePerOrder: 'Price Per Order',
  orderCountLimitExceed: 'Order count limit exceed.',
  code: 'Code',
  status: 'Status',
  select: 'Select',
  maxCapacity: 'Max capacity 999999!',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
  change: 'Change',
  copy: 'Copy',
  courierShiftReport: 'Courier Shift Report',
  courierDistanceReport: 'Courier Distance Report',
  polygonHaveMinThreePoints: 'Invalid polygon. At least 3 points are required.',
  polygonTooLarge: "Polygon area cannot exceed",
  polygonArea: 'Polygon Area',
  invalidPolygon: 'Invalid polygon!',
  import: 'Import',
  bulkAddAndUpdate: 'Bulk Add and Update',
  makeActiveOrPassive: 'Make Active or Passive',
  downloadExampleTemplate: 'Download Example Template',
  uploadReadyTemplate: 'Upload Ready Template',
  infoForBulkAddEdit:
    'In order to bulk upload, you need to upload an Excel in the format below.',
  infoForBulkAddEditCourier1:
    'If you want to add a new courier in bulk, all fields must be filled. If there is an empty field, the courier will not be added. ',
  infoForBulkAddEdit1:
    'If you want to make a batch update, simply fill in the starred fields and the fields you want to update. ',
  infoForBulkAddEditUser1:
    'If you want to add a new collector in bulk, all fields must be filled. If there is an empty field, the collector will not be added. ',
  infoForBulkActivePassiveUpdate:
    'You need to upload an Excel in the format below in order to collectively activate/deactivate.',
  zoneSlotImport: 'Zone Slot Import',
  infoForZoneSlotImport:
    'To load data in the correct format, please review the Description page in the sample template.With the bulk upload process, not only a new record is created, but also if there is a different match record on intersecting dates in the relevant zone, it also updates them.After uploading the relevant file, your records may not be processed into the system immediately. It can be monitored from a different screen regarding the status of the transaction or whether the data in the file gives errors.While the error details of the faulty rows are displayed on the relevant page, successful rows are processed.',
  bulkActivePassiveUpdate: 'Bulk Active Passive Update',
  onlyAcceptExcel:
    'Only files with .xls and .xlsx extensions should be uploaded.',
  fileUploadSuccess: 'File uploaded successfully.',
  selectFile: 'Please select a file!',
  fileUploadError:
    'An error occurred while uploading the file. Check the format.',
  common: {
    all: 'Tümü',
    eliteUser: 'Elite User',
    order: 'Order',
    orderStop: 'Stop',
    degree: 'Degree'
  },
  mainDashboard: {
    kpiPrimaryColor: '#4B7BE5',
    kpiWarningColor: '#FFCE55',
    kpiDangerColor: '#F26E53',
    kpiSuccessColor: '#5BC1A6',
    completedColor: '#5BC1A6',
    inTransitColor: '#FFCE55',
    cancelledColor: '#F26E53',
    kpiOnTimeDeliveryText: 'On-time Delivery Rate',
    kpiDeliveredOrderCountForToday: 'Today {{count}} orders are delivered',
    kpiOnTimeDeliveryLowColor: '#F26E53',
    kpiOnTimeDeliveryNormalColor: '#FFCE55',
    kpiOnTimeDeliveryHighColor: '#5BC1A6',
    kpiRouteComplianceRateToday: 'Route Compliance Rate',
    kpiRouteComplianceRateLowColor: '#F26E53',
    kpiRouteComplianceRateNormalColor: '#FFCE55',
    kpiRouteComplianceRateHighColor: '#5BC1A6',
    kpiIndividualInDistributionVehicleCountForToday:
      'In Distribution Vehicle Count',
    kpiRouteLengthText: 'Todays Calculated Routi Length',
    kpiChangedCourierCountForToday: 'Changed Courier Count',
    kpiExcludedOrderCountForToday: 'Excluded Order Count',
    kpiExcludedOrderCountForYesterday: 'Yesterday {{count}} orders excluded',
    kpiActiveOrderCountForToday: 'Today Order Count',
    kpiActiveOrderCountForYesterday: 'Yesterday {{count}} orders were created',
    kpiCurrentSlotOrderCountText: 'Current Slot Order Count',
    kpiNextSlotOrderCountText: 'There are {{count}} order for next slot',
    kpiReturnOrderCountForToday: 'Return Order Count',
    kpiReturnOrderCountForYesterday: 'Yesterday {{count}} orders were returned',
    kpiReplacedOrderCountForToday: 'Replaced Order Count',
    kpiReplacedOrderCountForYesterday: 'Yesterday {{count}} orders replaced',
    dashboardDeliverySummaryForToday: 'Delivery Stats By Slot',
    vehicleTemperatureAlert: 'Vehicle Temperature Alert',
    onTimeDeliveryRateToday: 'Today Time Delivery Rate',
  },
  fleetManagement: {
    vehicleType: 'Vehicle Type',
    changeVehicleType: 'Change Vehicle Type',
    vehicle: {
      assetCode: 'Asset Code',
      vehicleOwner: 'Vehicle Owner',
      vehicleParticipationDate: 'Vehicle Participation Date',
      operationParticipationDate: 'Operation Participation Date',
      modelYear: 'Model Year',
      vehicleUsageType: 'Vehicle Usage Type',
    },
  },
  bonusManagement: {
    component: 'Component',
    bonusComponents: 'Bonus Components',
    bonusRules: 'Bonus Rules',
    bonusOperations: 'Bonus Operations',
    componentName: 'Component Name',
    effect: 'Effect',
    weight: 'Weight',
    active: 'Active',
    isActive: 'Is Active?',
    passive: 'Passive',
    createdTime: 'Created Time',
    addedBonusParameter: 'Bonus Parameter Added!',
    addedBonusComponent: 'Bonus Component Added!',
    bonusComponent: 'Bonus Component',
    value: 'Value',
    select: 'Select',
    addNewRule: 'Add New Rule',
    rules: 'Rules',
    logicalConnective: 'Logical Connective',
    bracket: 'Bracket',
    vehicleType: 'Vehicle Type',
    vehicleUsageType: 'Vehicle Usage Type',
    distributionCenter: 'Distribution Center',
    numberOfDeliveredOrdersGte: 'Number Of Delivered Orders >=',
    numberOfDeliveredOrdersLte: 'Number Of Delivered Orders <=',
    actualTraveledDistanceGte: 'Actual Traveled Distance >=',
    actualTraveledDistanceLte: 'Actual Traveled Distance <=',
    paidLeaveHour: 'Paid Leave Hour',
    unpaidLeaveHour: 'Unpaid Leave Hour',
    weeklyLeaveHour: 'Weekly Leave Hour',
    numberOfPublicHolidayShift: 'Number Of Public Holiday Shift',
    workHour: 'Total Work Hour',
    totalLeaveHour: 'Total Leave Hour',
    rule: 'Rule',
    ruleList: 'Rule List',
    parameterList: 'Parameter List',
    componentList: 'Component List',
    selectComponent: 'Select Component',
    noBrackets: 'No Brackets',
    bonusComponentDelete: 'Selected component will be deactivated.',
    deletedBonusComponent: 'Selected component is deactivated.',
    deleteBonusComponent: 'Passive Selected Component',
    addedBonusOperations: 'Bonus operations added.',
    editedBonusComponents: 'Bonus Components Edited.',
    deleteOperation: 'Delete Operation',
    bonusOperationDelete: 'Selected operation will be deactivated.',
    deletedOperation: 'Selected operation is deactivated.',
    deleteOperationAndRecreate: 'Delete Operation and Recreate',
    predefinedRules: 'Predefined Rules',
    deleteRuleAndRecreate: 'Delete Rule and Recreate',
    bonusRuleDelete: 'Selected rule will be deactivated.',
    deleteRule: 'Delete Rule',
    deletedRule: 'Selected rule is deactivated.',
    warehouse: 'WareHouse',
    no: 'Number',
    period: 'Period',
    bonusId: 'Bonus ID',
    vehicleCount: 'Vehicle Count',
    totalPayCut: 'Total Pay Cut',
    totalPaymentAmount: 'Total Payment Amount',
    totalNetAmount: 'Total Net Amount',
    status: 'Status',
    plateNumber: 'Plate Number',
    distance: 'Distance(KM)',
    totalOrderCount: 'Total Delivered Order Count',
    publicHolidayCount: 'Public Holiday Count',
    payCutCount: 'Pay Cut Count',
    componentOne: 'Component One',
    componentTwo: 'Component Two',
    componentThree: 'Component Three',
    componentFour: 'Component Four',
    componentFive: 'Component Five',
    componentSix: 'Component Six',
    componentSeven: 'Component Seven',
    totalPay: 'Total Pay',
    calculateBonus: 'Bonus Calculate',
    orderCount: 'Order Count',
    approved: 'Approved',
    notApproved: 'Not Approved',
    bonusApproveTitle: 'Bonus Approve',
    approveBonus: 'Approve',
    cancel: 'İptal',
    ok: 'Ok',
    bonusApproveMessage: 'Are you sure you want to approve the bonus?',
    editPreparedData: 'Edit Prepared Data',
    selectBonusPeriod: 'Select Bonus Period',
    dontDeletedApprovedData: 'You can not delete approved data!',
    bonusSummary: 'Bonus Summary',
    courier: 'Courier',
    notificationDate: 'Notification Date',
    cutReason: 'Reason For Pay Cut ',
    price: 'Price For Pay Cut',
    courierPayCutDelete: 'Selected pay cut will be deactivated.',
    deleteCourierPayCut: 'Delete Pay Cut',
    deletedCourierPayCut: 'Selected pay cut is deactivated.',
    addedCourierPayCut: 'Pay Cut added.',
    courierPayCut: 'Courier Pay Cut',
    customerComplaint: 'Customer Complaint',
    other: 'Other',
    description: 'Description',
    editedCourierPayCut: 'Pay Cut edited.',
    addedWorkingHours: 'Working Hours added.',
    workingHours: 'Working Hours',
    zone: 'Zone',
    dailyWorkingHour: 'Daily Working Hour',
    operationOrderIncorrect:
      'The order of operation is incorrect, please check!',
    parameter: 'Parameter',
    bonusComponentParameters: 'Bonus Component Parameters',
    addNewParameter: 'Add New Parameter',
    deleteParameter: 'Delete Parameter',
    selectParameter: 'Select Parameter',
    ruleName: 'Rule Name',
    ruleDefinitions: 'Rule Definitions',
    subRuleDefinitions: 'Subrule Definitions',
    reportName: 'BonusDetailReport.xlsx',
    VAN: 'Van',
    MOTORCYCLE: 'Motorcycle',
    DEDICATED: 'Dedicated',
    SPOT: 'Spot',
    prepareData: 'Prepare Data',
    addValue: 'Add Constant',
    selectDate: 'Select Date',
    selectRule: 'Select Rule',
    ruleDefinitionList: 'Rule Definition List',
    parameters: 'Parameters',
    ruleDefinition: 'Rule Definition',
    addRuleDefinition: 'Add Rule Definition',
    addNewOperationExistingWillBeDeleted:
      'If you add a new operation,the existing operation will be deleted.',
    selectEffect: 'Select Effect',
    selectActivity: 'Select Activity',
    selectDistCenter: 'Select Distribution Center',
    selectCourier: 'Select Courier',
    selectPlate: 'Select Plate',
    selectCutReason: 'Select Cut Reason',
    definedAnyOperation:
      'You do not have an operation defined, please define an operation first!',
  },
  zoneManagement: {
    zoneName: 'Zone Name',
    zoneType: 'Zone Type',
    storeName: 'Store Name',
    definedAnyPolygon:
      'You do not have an area defined, please define an area!',
    zoneDelete: 'Zone Delete',
    orderZone: 'Order Zone',
    storeZone: 'Store Zone',
    status: 'Status',
    selectZoneType: 'Select Zone Type',
    zoneColor: 'Zone Color',
    showCustomers: 'Show Customers',
    transparency: 'Transparency',
    zoneAdd: 'Add Zone',
    zoneStatus: 'Zone Status',
    selectZoneStatus: 'Select Zone Status',
    note: 'Note',
    saveAndSendForApproval: 'Save And Send For Approval',
    zoneApprovalStatus: 'Zone Approval Status',
    selectZoneApprovalStatus: 'Select Zone Approval Status',
    approvalStatus: 'Approval Status',
    selectParentOfZone: 'Select Parent Of Zone',
    parentOfZone: 'Parent of Zone',
    zoneCode: 'Zone Code',
    saveAndApprove: 'Save And Approve',
    updater: 'Updater',
    updatedDate: 'Updated Date',
    inUse: 'In Use',
    isInUse: 'Is In Use?',
    notInUse: 'Not In Use',
    recommendIsochroneZone: 'Recommend Isochrone Zone',
    popupText: 'Enter duration (Recommended: 6.0): ',
    isCreateDefaultSlots: 'Create Default Slots',
    selectedDeliveryModel: 'Select Delivery Model',
  },
  slotManagement: {
    changeCourierReturnIndicator: 'Change Courier Return Indicator',
    changeCourierReturnIndicatorModalHeader:
      'Change Distribution Center Return Necessity',
    changeCourierReturnIndicatorInfo:
      'For {{slot}} slot you can change return necessity to distribution center of courier with below options by day of week.',
    templateName: 'Template Name',
    templateCode: 'Template Code',
    isMainTemplate: 'Is Main Template',
    mainTemplate: 'Main Template',
    description: 'Description',
    status: 'Status',
    changeStatus: 'Change Status',
    slotTemplates: 'Slot Templates',
    templateStatusChanged: 'Template status changed.',
    templateEdited: 'Templates edited.',
    deleteTemplate: ' templates will be deleted.',
    changeStatusTemplate: ' templates will be changed status.',
    delete: 'Delete',
    templateDeleted: 'Template deleted.',
    defaultTemplateForAllMessage:
      'The main template is currently selected. Do you still want to change',
    slotsCapacity: 'Capacity',
    addTemplateSuccess: 'Template added.',
    createAutoSlot: 'Create Auto Slot',
    createSlot: 'Create Slot',
    startAndFinishDate: 'Start and Finish Date',
    slotRange: 'Slot Range',
    startTime: 'Start Time',
    finishTime: 'Finish Time',
    cannotBeSplit:
      'The slot interval must be split exactly between the start and end times!',
    youHaveSlots:
      'You have a slot already added on the day the slot will be created, do you want to create it anyway?',
    youHaveAlreadySlotsForCopy:
      'Available slots will be updated on the days you copy. Do you confirm ?',
    editTemplateSuccess: 'Template edited.',
    editTemplate: 'Edit Template',
    addTemplate: 'Add Template',
    applyAllDays: 'Apply All Days',
    hasConflictMessage:
      'There is a conflict between the selected dates. If you confirm, the new template will be valid.',
    applyTemplate: 'Apply Template',
    changeStatusSuccess: 'Slot Template status changed.',
    deleteSuccessMessage: 'Selected Slot Templates Deleted.',
    cutOffTime: 'Cut Off Time',
    deleteConfirmMessage:
      'Are you sure you want to delete the selected slot templates?',
    changeStatusConfirmMessage:
      'Are you sure you want to change the status of the selected slot templates?',
    masterTemplateCannotBeDeleted: 'Master Template cannot be deleted.',
    newSlot: 'New Slot',
    autoSlot: 'Auto Slot',
    copySlot: 'Copy Slot',
  },
  routingDetail: {
    orderRequestedSize: 'Total Orders',
    planned: 'Planned',
    orderExcludedSize: 'Unplanned',
    expeditionCount: 'Expediton Count',
    courierIncludedSize: 'Vehicle',
    totalDistanceInMeter: 'Estimated Distance',
    estimatedRouteLength: 'Estimated Distance',
    calculatedRouteLength: 'Actual Distance',
    totalDurationInSecond: 'Total Planned Route Duration',
    orderDeliverySuccessRate: 'Route Completion',
    distributionStart: 'Distribution Start',
    distributionEnd: 'Distribution End',
    estimatedArrivalTime: 'Estimated Delivery Time',
    actualArrivalTime: 'Actual Delivery Time',
    calculationError: 'Calculation is not possible due to wrong GPS signal!',
    lastCalculationTime: 'Last Calculation Time',
    doubleDistributor: 'Switch shipments between two distributors',
    doubleDistributorDesc:
      'Allows shipments to be exchanged between two distributors',
    shareDistributor:
      'Assign the entire shipment to another distributor or share it between distributors',
    shareDistributorDesc:
      'Allows you to assign the entire shipment to another distributor or share it among other distributors',
    courierAndOrderRequired:
      'Please Do Not Leave the Distributor and Order Fields Blank',
    changeDistributor: 'Change Distributor',
    selectChangeDistributorOptions:
      'Select the Distributor Change Operation You Want to Perform',
    sourceCourier: 'Resource Distributor',
    reqSourceCourier: 'Source Distributor Cannot Be Blank',
    reasonForChange: 'Reason for Change',
    reqReasonForChange: 'Reason for Change Cannot Be Left Blank',
    selectDestinationCourier: 'Select Destination Courier',
    selectOrders: 'Select Orders',
    againRouting: 'Reroute',
    againRoutingDesc:
      'After changing the distributor, a rerouting is required to reflect the courier change. Can you make a new distributor change or routing?',
    changeRedistributor: 'Change Redistributor',
    VEHICLE_BREAKDOWN: 'VEHICLE BREAKDOWN',
    COURIER_DISCOMFORT: 'COURIER DISCOMFORT',
    VEHICLE_ACCIDENT: 'VEHICLE ACCIDENT',
    WRONG_COURIER: 'WRONG COURIER',
    COMPANY_INCORRECT_INFORMATION: 'COMPANY INCORRECT INFORMATION',
    INSUFFICIENT_DOCUMENTATION: 'INSUFFICIENT DOCUMENTATION',
    LACK_OF_COURIER: 'LACK OF COURIER',
    OUT_OF_OPERATION: 'OUT OF OPERATION',
    changeCourierMinReq: 'Undelivered orders cannot be found.',
    reRouteSuccess: 'The routing operation was completed successfully.',
    distributionStartAndEndTime: 'Distribution Start/End Time',
    plannedStartAndEndTime: 'Planned Start/End Time',
  },
  courierChange: 'Courier Change',
  routeCourierManagement: {
    changeCourier: 'Chanege Courier',
    changeReason: 'Change Reason',
    sourceCourier: 'Source Courier',
    targetCourier: 'Destination Courier',
    courierChangeBackgroundColor: '#2e9ffc',
    addNewTargetCourier: 'Add New Target Courier',
    changeWorkOrdersBetweenCouriers: 'Change Work Orders Between Couriers.',
    changeWorkOrdersBetweenCouriersLabel:
      'It allows batch exchange of work orders among couriers included in the route.',
    assignAllWorkOrdersToAnotherCourier:
      'Assign All Work Orders to Another Courier.',
    assignAllWorkOrdersToAnotherCourierLabel:
      'It allows us to assign all work orders from one courier to another courier. The couriers do not change between them, they assign what is on the courier to someone else.',
    splitWorkOrdersToOtherCouriers: 'Split Work Orders to Other Couriers.',
    splitWorkOrdersToOtherCouriersLabel:
      'It allows the assigned work orders to be shared one by one to any courier included or not included in the routing.',
    targetCourierInfoNotFound: 'Target Courier information not found.',
  },
  courierGroupDelete: 'Selected courier group will be deactivated.',
  deletedCourierGroup: 'Selected courier group is deactivated.',
  addedCourierGroup: 'Courier group added.',
  assignedSlots: 'Assigned Slots',
  courierGroupAdd: 'Add Courier Group',
  editedCourierGroup: 'Courier group edited.',
  courierGroupEdit: 'Courier Group Edit',
  courierGroupName: 'Courier Group Name',
  validityDates: 'Validity Dates',
  validityStartDate: 'Start Date',
  validityEndDate: 'End Date',
  startAndEndDate: 'Start - End Date',
  courierList: 'Couriers',
  noData: 'No Data',
  courierGroupInfo: 'Courier Group Informations',
  pickDate: 'Pick Date',
  loadingLiveFeed: 'Waiting for vehicle data to load...',
  operatingConditions: 'Operating Conditions',
  willRunDynamicCapacity: 'Run Dynamic Capacity for the Selected Zone',
  durationBetweenOrder: 'Time Between Orders (min)',
  runFrequency: 'Program Working Frequency (min)',
  alertTime: 'Alarm Clock',
  temperature: 'Temperature',
  yesterday: 'Yesterday',
  mainParameters: 'Main Parameters',
  selectAllSlots: 'Select/Remove All Slots',
  errorMessageNoCourier: 'No courier selected for routing',
  errorMessageNoOrder: 'No order selected for routing',
  selectSlot: 'Select slot',
  notAuthorized: 'Sorry, you are not authorized to access this page.',
  returnManually: 'Return manually',
  boxStatusLost: 'LOST',
  number: 'Number',
  numberOfSlotReleased: 'Number of Slots Released',
  numberOfSlotsScheduled: 'Number of Slots Scheduled',
  actualDeliveryDate: 'Actual Delivery Date',
  actualDeliveryTime: 'Actual Delivery Time',
  allWarehouses: 'All Warehouses',
  orders: {
    refreshOrders: 'Refresh Orders',
    locationValidated: 'Location Validated',
    locationNotValidated: 'Location not Validated',
    hasFrozenProduct: 'Order Contains Frozen Products',
    waitingToPickup: 'Waiting to Pickup for Volume Info',
    notFitInMotorcycle: 'Not Fit in Motorcycle',
    motorVolume: 'Motorcycle Volume',
  },
  vehiclePlanningReport: {
    reportName: 'VehiclePlanningReport.xlsx',
    taskId: 'Task Id',
    deliveryDate: 'Delivery Date',
    distributionCenter: 'Distribution Center',
    zone: 'Zone',
    slot: 'Slot',
    requestedVehicleCount: 'Requested Vehicle Count',
    includedVehicleCount: 'Included Vehicle Count',
    actualVehicleCount: 'Actual Vehicle Count',
  },
  vehicleWorkHour: {
    warehouseName: 'Distribution Center',
    workDate: 'Work Date',
    plateNumber: 'Plante',
    zoneName: 'Zone Name',
    workHour: 'Work Hour',
    leaveType: 'Leave Type',
    leaveHour: 'Leave Name',
    vehicleWorkHourEdit: 'Edit Vehicle Work Hour',
    editedVehicleWorkHour: 'Vehicle Work Hour Edited',
  },
  enum: {
    PICKING: 'Picking',
    PICKED: 'Picked',
    NOT_PICKED: 'Not Picked',
    tooltipPICKING: 'Order is being Picked',
    tooltipPICKED: 'Order has been Picked',
    tooltipNOT_PICKED: 'Order has not been Picked Yet',
    Slot: 'Slot',
    Return: 'Return',
    Replaced: 'Replaced',
    VAN: 'Van',
    MOTORCYCLE: 'Motor',
    POSITIVE: 'Positive (+)',
    NEGATIVE: 'Negative (-)',
    AND: 'AND',
    OR: 'OR',
    DEDICATED: 'Dedicated',
    SPOT: 'Spot',
    WEEKLY: 'Weekly',
    PAID: 'Paid',
    UNPAID: 'Unpaid',
    CUSTOMER_COMPLAINT: 'Customer Complaint',
    OTHER: 'Other',
  },
  placeholder: {
    startDate: 'Start Date',
    endDate: 'End Date',
    selectWarehouseDisplayReports: 'Select the warehouse to display reports.',
    searchOrder: 'Order search..',
    selectCourier: 'Select courier!',
    selectSourceCourier: 'Select source courier!',
    selectTargetCourier: 'Select target courier!',
    selectChangeReason: 'Select change reason!',
    selectOrders: 'Select orders!',
    selectOperation: 'Select operation!',
    selectDate: 'Tarih Seçiniz!',
    day: 'Day',
    month: 'Month',
  },
  alert: {
    selectDateRange: 'Please select date range!',
    selectWarehouse: 'Please select warehouse!',
    fillField: 'Please fill this field!',
    notValidEmail: 'The input is not valid E-mail!',
    notValidPhone: 'The input is not valid phone!',
    onlyPositiveValues: 'Negative value cannot be entered!',
    maxLengthExceeded: 'You have exceeded the maximum number of characters (max 64 character)!',
    maxLength10Character: 'You have exceeded the maximum number of characters (max 10 character)!',
    storeSlotRequired: 'Store/Slot creation options are required!',
    onlyNumbers: 'Can only include numbers!',
    pleaseUploadExcelFile: 'Lütfen Excel dosyası yükleyiniz!',
  },
  NEW_ORDER: 'New Order',
  COLLECTING: 'Collecting',
  SEMI_COLLECTED: 'Semi Collected',
  COLLECTED: 'Collected',
  IN_TRANSIT: 'In Transit',
  AT_CUSTOMER_ADDRESS: 'At Customer Address',
  DELIVERED: 'Delivered',
  NOT_DELIVERED: 'Not Delivered',
  ARRIVED_AT_STORE: 'Arrived at Store',
  COMPLETED: 'Completed',
  REFUNDED: 'Refunded',
  ASSIGNED_TO_COURIER: 'Assigned To Courier',
  RETURN_REQUEST_RECEIVED: 'Return Order Received',
  COURIER_ON_RETURN_PICKUP_WAY: 'Courier Took Return Order, On the Way',
  PICK_UP_AT_CUSTOMER: 'Courier At Customer Address For Return',
  RETURN_PICKED_UP: 'Product Physically Picked Up From Customer',
  RETURN_PICKUP_MISSED: 'Courier Arrived But Could Not Pick Up',
  RETURN_PICKUP_COMPLETED: 'Return Completed',
  RETURN_PICKUP_REJECTED: 'Return Rejected',
  RETURNED_TO_STORE: 'Return Order Arrived at Store',
  capacityPlanDashboard: 'Capacity Plan Dashboard',
  courierPerfromanceDashboard: 'Courier Performance Dashboard',
  session_expired: 'Your session has expired. Please login again',
  colorWhite: '#FFFFFF',
  orderInformation: 'Order Information',
  watchRoute: 'Watch Route',
  pleaseSelectSlot: 'Couriers will be shown after slot selection',
  deliveryStart: 'Delivery Start',
  deliveryEnd: 'Delivery End',
  deliveryCount: 'Delivery Count',
  hideShowOrders: 'Hide/Show Orders',
  order: 'Order',
  station: 'Stop',
  compliance: 'Compliance',
  watchLive: 'Watch Live',
  inTransitCourierDashboard: ' - On distribution',
  notInTransitCourierDashboard: ' - Not in Distribution',
  totalDistance: 'Total Distance:',
  plannedDistance: 'Planned Distance:',
  traveledDistance: 'Traveled Distance:',
  orderCompletionPercentage: 'Order Completion Percentage',
  selectSubZone: 'Select sub zone',
  blueColorCode: '#120A8F',
  timeWithSecond: 'Duration (MIN)',
  usedApi: 'Used API',
  orderCount: 'Order Count',
  courierCount: 'Courier Count',
  distanceWithKm: 'Distance (KM)',
  parameterProfile: 'Parameter Profile',
  information: 'Information',
  planningDeliveryTime: 'Planning Delivery Time',
  map: {
    airDistance: 'Air Distance:',
  },
  publicHoliday: {
    publicHolidayDelete: 'Selected public holiday will be deactivated.',
    publicHolidayName: 'Public Holiday Name',
    publicHolidayStartDate: 'Date',
    publicHolidayPeriod: 'holiday period',
    publicHolidayAdded: 'Public holiday added',
    publicHolidayEdit: 'Public Holiday Edit',
    publicHolidayAdd: 'Public Holiday Add',
    editedPublicHoliday: 'Public holiday edited',
    deletedPublicHoliday: 'Selected public holiday will be deactivated.'
  },
  progressPayment: {
    invoice: 'Invoice',
    progressPaymentLabel: 'Invoice Information', 
    progressPaymentType: 'Invoice Type', 
    otifValueTitle: 'OTIF Value (Daily/Monthly)',
    otifDailyValue: 'Daily OTIF',
    otifMonthlyValue: 'Monthly OTIF',
    ADVANCE_PAYMENT: 'First Payment',
    PROGRESS_PAYMENT: 'End of Month Payment', 
    totalPrice: 'Amount Excluding VAT',
    price: 'Amount Including VAT', 
    processId: 'Transaction Number', 
    processStatus: 'GIB Status',
    FAILED: 'Failed', 
    IN_PROGRESS:  'In Progress',
    SUCCESS: 'Successful',
    erpSentSucceeded: 'ERP Status',
    true: 'Sent', 
    false: 'Not Sent', 
    courierIdentityNumber1: '1.TCKN to be Invoiced',
    courierIdentityNumber2: '2.TCKN to be Invoiced',
    invoiceApprovalInfoTitle: 'Invoice Approval Information',
    invoiceApprovalProgressPaymentType: 'Pending Invoice Type',
    approvedUserId: 'Approved By User ID',
    approvedNameSurname: 'Approved By',
    approvedDate: 'Approval Date',
    approveProgressPaymentInvoice: 'Approve End of Period Invoice',
    approveAdvancePaymentInvoice: 'Approve Advance Invoice',
    invoiceApprovedSuccessfully: 'Invoice approved',
  },
  taxPlate: 'Tax Plate',
  bankBook: 'Bank Book',
  authorizedSignatures: 'Authorized Signatures',
  signatureCircular: 'Signature Circular',
  vehicleRegistration: 'Vehicle Registration',
  criminalRecord: 'Criminal Record',
  carInsurance: 'Car Insurance',
  driverLicense: 'Driving License',
  socialInsurance: 'Courier Employment Contract',
  employmentAgreement: 'Employment Agreement',
  submit: 'Submit',
  clear: 'Clear',
  filter: 'Filter',
  ordersTitle: 'Orders',
  couriersTitle: 'Couriers',
  vehicleGroupsTitle: 'Vehicle Groups',
  totalCashFee: 'Total Cash Fee',
  totalCreditCardFee: 'Total Credit Card Fee',
  totalFee: 'Total Fee',
  totalOtherFee: 'Other Payments',
  totalVoucherFee: 'Payment by Total Wallet',
  totalMasterpassFee: 'Total Masterpass',
  totalGiftCardFee: 'Total Gift Card',
  MASTERPASS: 'Masterpass',
  CASH_ON_DELIVERY: 'Cash On Delivery',
  CASH_ON_DELIVERY_BY_CREDIT_CARD: 'Cash On Delivery By Credit Card',
  PAYMENT_BY_VOUCHERS: 'Payment By Wallet',
  PAYMENT_BY_GIFT_CARD: 'Payment By Gift Card',
  OTHER_PAYMENTS: 'Other',
  GIFT_CARD: 'Gift Card',
  WALLET: 'Wallet',
  MANAGER: 'MANAGER',
  COLLECTOR: 'COLLECTOR',
  REGIONAL_MANAGER: 'REGIONAL MANAGER',
  STORE_MANAGER: 'STORE MANAGER',
  REGIONAL_EXECUTIVE: 'REGIONAL EXECUTIVE',
  CENTRAL_HR_EXECUTIVE: 'CENTRAL HR EXECUTIVE',
  BRANCH_MANAGER: 'BRANCH MANAGER',
  CENTRAL_OPERATIONS_OFFICER: 'CENTRAL OPERATIONS OFFICER',
  REGIONAL_HR_EXECUTIVE: 'REGIONAL HR EXECUTIVE',
  LOGISTICS_EXECUTIVE: 'LOGISTICS EXECUTIVE',
  ECOM_OPERATIONS_SPECIALIST: 'ECOM OPERATIONS SPECIALIST',
  NOT_ECOM_STORE_MANAGER: 'NOT ECOM STORE MANAGER',
  CENTRAL_OPERATIONS_EXECUTIVE: 'CENTRAL OPERATIONS EXECUTIVE',
  CENTRAL_OPERATIONS_VIEWER: 'CENTRAL OPERATIONS VIEWER',
  COURIER: 'COURIER',
  REGIONAL_DIRECTOR: 'REGIONAL DIRECTOR',
  STORE_SALER: 'STORE SALER',
  BRANCH_MANAGER_SUPPORTER: 'BRANCH MANAGER SUPPORTER',
  REGIONAL_MANAGER_SUPPORTER: 'REGIONAL MANAGER SUPPORTER',
  REGIONAL_EXECUTIVE_SUPPORTER: 'REGIONAL EXECUTIVE SUPPORTER',
  BUDDY_MANAGER_CANDIDATE: 'BUDDY MANAGER CANDIDATE',
  STORE_MANAGER_2_0: 'STORE MANAGER 2.0',
  STORE_MANAGER_CANDIDATE: 'STORE MANAGER CANDIDATE',
  STORE_MANAGER_SUPPORTER: 'STORE MANAGER SUPPORTER',
  STORE_MANAGER_SUPPORTER_MINI: 'STORE MANAGER SUPPORTER MINI',
  STORE_MANAGER_SUPPORTER_CANDIDATE: 'STORE MANAGER SUPPORTER CANDIDATE',
  STORE_SALER_PART_TIME: 'STORE SALER PART TIME',
  STORE_SALER_MINI: 'STORE SALER MINI',
  STORE_SALER_SEASON: 'STORE SALER SEASON',
  STORE_SALER_MANAGER_CANDIDATE: 'STORE SALER MANAGER CANDIDATE',
  NOT_ECOM_USER: 'NOT ECOM USER',
  NOT_ECOM_STORE_SALER: 'NOT ECOM STORE SALER',
  NOT_ECOM_BUDDY_MANAGER_CANDIDATE: 'NOT ECOM BUDDY MANAGER CANDIDATE',
  NOT_ECOM_STORE_MANAGER_2_0: 'NOT ECOM STORE MANAGER 2.0',
  NOT_ECOM_STORE_MANAGER_CANDIDATE: 'NOT ECOM STORE MANAGER CANDIDATE',
  NOT_ECOM_STORE_MANAGER_SUPPORTER: 'NOT ECOM STORE MANAGER SUPPORTER',
  NOT_ECOM_STORE_MANAGER_SUPPORTER_MINI: 'NOT ECOM STORE MANAGER SUPPORTER MINI',
  NOT_ECOM_STORE_MANAGER_SUPPORTER_CANDIDATE: 'NOT ECOM STORE MANAGER SUPPORTER CANDIDATE',
  NOT_ECOM_STORE_SALER_PART_TIME: 'NOT ECOM STORE SALER PART TIME',
  NOT_ECOM_STORE_SALER_MINI: 'NOT ECOM STORE SALER MINI',
  NOT_ECOM_STORE_SALER_SEASON: 'NOT ECOM STORE SALER SEASON',
  NOT_ECOM_STORE_SALER_MANAGER_CANDIDATE: 'NOT ECOM STORE SALER MANAGER CANDIDATE',
  NOT_ECOM_BRANCH_MANAGER_SUPPORTER: 'NOT ECOM BRANCH MANAGER SUPPORTER',
  NOT_ECOM_REGIONAL_MANAGER_SUPPORTER: 'NOT ECOM REGIONAL MANAGER SUPPORTER',
  NOT_ECOM_REGIONAL_EXECUTIVE_SUPPORTER: 'NOT ECOM REGIONAL EXECUTIVE SUPPORTER',
  NOT_APPROVED: 'Not Confirmed',
  NEW: 'New',
  HAS_NEW_VERSION_FOR_APPROVAL: 'New Version Pedding Approval',
  CANCELLED: 'Cancelled',
  ON_HOLD: 'ON_HOLD',
  IN_DISTRIBUTION: 'IN_DISTRIBUTION',
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  productImage: 'Product Image',
  productCode: 'Product Code',
  excessTotal: 'Excess Total',
  missingTotal: 'Missing Total',
  productEdit: 'Product Edit',
  productPrice: 'Product Price',
  overCollectionPercentage: 'Over Collection Percentage',
  underCollectionPercentage: 'Missing Collection Percentage',
  open: 'Open',
  close: 'Close',
  editedOrderItemProperty: 'Weighted product edited',
  totalOrderCount: 'Number of Orders for Daily Distribution',
  notDeliveredOrderCount: 'Number of Undeliverable Orders',
  firstPackageTakingTime: 'Delivery Date of The First Order',
  lastPackageDeliverTime: 'Delivery Date of The Last Order',
  timeDiff: 'Time Interval Between The Two Orders',
  statusActivated: 'Registration Activated Successfully.',
  zoneActiveQuestion: 'Are you sure you want to activate this zone?',
  zonePassiveQuestion: 'Are you sure you want to deactivate this zone?',
  externalCreateTimeGe: 'Creation Date Start',
  externalCreateTimeLe: 'Creation Date End',
  currentNumber: 'Current Number',
  bringCompetitorStores: 'Bring Competitor Stores',
  arrivedCompetitorStores: 'Competitor Stores Arrived',
  cleanCompetitorStores: 'Clean Competitor Stores',
  zoneMove: 'Zone Move',
  zoneRevert: 'Zone Revert',
  zoneRevertMessage: 'Do you want to transfer this zone back to the old store?',
  expandMap: 'Expand Map',
  showList: 'Show List',
  values: 'Values',
  distanceLimit: 'Distance Limit (meter)',
  leastOneSlotMessage: 'Please add at least one slot per day !!!',
  dontLeaveSpace: 'Please do not leave any spaces',
  dataNotSavedWarningMessage:
    'The information you added will be canceled. Are you sure?',
  searchAcrossTurkey: 'Search Across Turkey',
  acrossTurkey: 'Across Turkey',
  selectedOrderCount: 'Selected Order Count',
  totalOrderCountForRouting: 'Total Order Count',
  orderSearch: 'Order Search',
  selectedCourierCount: 'Selected Courier Count',
  totalCourierCountForRouting: 'Total Courier Count',
  courierSearch: 'Courier Search',
  delay: 'Delay',
  containsFrozen: 'Contains Frozen Product',
  fastDelivery: 'Fast Delivery',
  fastDeliveryDuration: 'Immediate Delivery Slot Duration (min)',
  eliteCustomer: 'Elite Customer',
  collected: 'Collected',
  collecting: 'Collecting',
  notCollected: 'Not Collected',
  selectAllCurrentOrders: 'Select All Current Orders',
  showPastOrders: 'Show Past Orders',
  orderStatus: 'Order Status',
  addressLocation: 'Address Lat/Lon',
  storeLocation: 'Store Lat/Lon',
  storeLongitude: 'Store Lon',
  storeLatitude: 'Store Lat',
  addressLatitude: 'Order Lat',
  addressLongitude: 'Order Lon',
  estimatedDistance: 'Estimated Distance',
  distributionStartEndDate: 'Distribution Start/End Date',
  plannedActualDistance: 'Planned/Actual Distance',
  deliveryCompletionPercentage: 'Delivery Completion Percentage',
  scheduledDeliveryDate: 'Scheduled Delivery Date',
  happeningDeliveryDate: 'Happening Delivery Date',
  district: 'District',
  isOpen: 'Is Open?',
  ccStatus: 'CC Status',
  ecomStatus: 'ECOM Status',
  faxNumber: 'Fax Number',
  phoneNumber2: 'Phone Number 2',
  shipmentType: 'Shipment Type',
  list: 'List',
  excelImportExport: 'Excel Import/Export',
  listOrCalender: 'Calender/List View',
  maxSelectedDateRange: 'Maximum selected date range is 30 days',
  maxSelectedDateRangeTwoDays: 'Maximum selected date range is 2 days',
  authorizedName: 'Authorized Name',
  authorizedNumber: 'Authorized Number',
  authorizedNumber2: 'Authorized Number 2',
  authorizedMail: 'Authorized Mail',
  roleMail: '(Role) Mail',
  branchName: 'Branch Name',
  branchManager: 'Branch Manager',
  branchManagerMail: 'Branch Manager Mail',
  branchManagerPhoneNum: 'Branch Manager Phone Number',
  branchCode: 'Branch Code',
  deliveryModel: 'Delivery Model',
  paymentMethod: 'Payment Methods',
  regionalInfo: 'Region Info',
  branchInfo: 'Branch Info',
  CLOSED: 'CLOSED',
  TEMPORARY_CLOSED: 'TEMPORARY CLOSED',
  WAITING: 'WAITING',
  OPEN: 'OPEN',
  BOX: 'BOX',
  editedStore: 'Store edited.',
  distributionStartTime: 'Distribution Start Time',
  numberOfOrdersCarried: 'Number of Orders Carried',
  CLOSE: 'Close',
  PENDING: 'Pending',
  TEMPORARILY_CLOSED: 'Temporarily Closed',
  obaseStatus: 'Obase Status',
  deliveryType: 'Delivery Type',
  collectionType: 'Collection Type',
  alternativeProduct: 'Alternative Product',
  isAlternativeProduct: 'Is the alternative product suitable?',
  BAG: 'BAG',
  CARD_ON_DELIVERY: 'Card On Delivery',
  home_code: 'Delivery at Home',
  CALCULATING: 'Calculating',
  DISTRIBUTION_STARTED: 'Distribution Started',
  DISTRIBUTION_COMPLETED: 'Distribution Completed',
  ERROR: 'Route Failed to Calculate',
  routingSolveStatus: 'Routing Status',
  routingStartTime: 'Routing Start Time',
  routingDoneTime: 'Routing Done Time',
  routingStartAndDoneTime: 'Routing Start - Done Time',
  startTime: 'Start Time',
  endTime: 'End Time',
  FAST: 'Fast',
  CARGO: 'Cargo',
  SLOT: 'Slot',
  IN_STORE: 'In Store',
  NO_SHIPMENT: 'No Shipment',
  orderDate: 'Order Date',
  youHavePastOrders:
    'The selected orders will be routed for the time slot {{slotString}}. Are you sure?',
  doYouConfirm: 'Do you confirm?',
  routesSelectedWillDeleted: 'Selected routes will be deleted !!!',
  areYouSureRoutesSelectedWillDeleted:
    'Are you sure you want to delete the selected routes?',
  plannedRouteEndTime: 'Planned Route End Time',
  completedAndTotalOrders: 'Completed/Total Orders',
  slotStartDate: 'Slot Start Time',
  slotEndDate: 'Slot End Time',
  customerFullName: 'Customer Full Name',
  customerPhoneNumber: 'Customer Phone Number',
  orderStatusReport: 'Order Status Report',
  orderDeliveryDate: 'Order Delivery Date',
  orderPlacementDate: 'Order Placement Date',
  orderSlot: 'Order Slot',
  customerId: 'Customer ID',
  cancelReturnStatus: 'Cancel Return Status',
  cancellationReason: 'Cancellation Reason',
  nonDeliveryReason: 'Non Delivery Reason',
  collectionStartDate: 'Collection Start Date',
  collectionEndDate: 'Collection End Date',
  collectionTime: 'Collection Time (min)',
  courierDeliveryDate: 'Courier Delivery Time',
  customerDeliveryDate: 'Customer Delivery Time',
  deliveryTime: 'Delivery Time (min)',
  totalPrice: 'Total Price (TL)',
  refundedPrice: 'Refunded Price (TL)',
  refundAmountForUnavailableProduct:
    'Refund Amount For Unavailable Product (TL)',
  partialRefundAmount: 'Partial Refund Amount (TL)',
  customerCollectedAmount: 'Customer Collected Amount',
  collectorFullName: 'Collector',
  courierFullName: 'Courier',
  coordinatesOfCustomer: 'Coordinates Of Customer',
  orderNumber: 'Order Number',
  returnOrder: 'Return Order',
  mainZone: 'Main Zone',
  zoneType: 'Zone Type',
  zoneStatus: 'Zone Status',
  note: 'Note',
  isMainZone: 'Is main zone?',
  today: 'Today',
  tomorrow: 'Tomorrow',
  confirmDeleteRow: 'Are you sure you want to delete this row?',
  enterCapacity: 'Enter the capacity!',
  occupancy: 'Occupancy',
  slotsEdited: 'Slotlar düzenlendi.',
  orderDeliveryDateRange: 'Order Delivery Date Range',
  orderChannel: 'Order Channel',
  capacityOnlyPositiveValues: 'Please enter positive value for capacity!',
  validityDate: 'Validity Date',
  targetRegion: 'Target Region',
  targetGroup: 'Target Group',
  orderCity: 'Order City',
  CRAFTMAN: 'Craftman',
  REGULAR: 'Regular',
  templateName: 'Template Name',
  mainTemplate: 'Main Template',
  isMainTemplate: 'Is Main Template?',
  selectStatus: 'Select Status',
  newTemplate: 'New Template',
  invoice: 'Invoice',
  pricing: 'Pricing',
  MONTHLY: 'Monthly',
  billingFrequency: 'Billing Frequency',
  invoiceType: 'Invoice Type',
  invoiceTime: 'Invoice Time',
  fixedWage: 'Fixed Wage',
  fixedVestingMethod: 'Vesting Method',
  fixedVestingTemplateName: 'Fixed Vesting Template Name',
  perOrder: 'Per Order',
  eInvoice: 'E-Invoice',
  templateWillBeValid: 'Template Will Be Valid;',
  minPieceGreaterThanMaxPiece:
    'Min must be greater than the previous Max.',
  minPiece: 'Min Piece',
  maxPiece: 'Max Piece',
  maxPieceMustBeGreaterThanMinPiece:
    'Max Piece must be greater than Min Piece!',
  priceMustBeGreaterThanPrevious:
    'Price must be greater than the previous price.',
  WORKING_HOURS: 'WORKING HOURS',
  CUSTOMER_SATISFACTION: 'CUSTOMER SATISFACTION',
  MIN_WORK_HOUR: 'MIN WORK HOUR',
  PAY_DAY_APPLICATION_ACTIVITY: 'PAY DAY APPLICATION ACTIVITY',
  DAYS: 'DAYS',
  HOURS: 'HOURS',
  valueMustBeBetween1And24: 'Value must be between 1 and 24.',
  valueMustBeBetween1And28: 'Value must be between 1 and 28.',
  ORDER_COUNT: 'Per Order',
  WORKING_HOURS: 'Per Working Hour',
  workingHoursPrice: 'Working Hours Price',
  dailyMaximumPrice: 'Daily Earn Price Max',
  ELECTRONIC: 'E-Invoice',
  cities: 'Cities',
  EXPEDITION_COUNT: 'Expedition Count',
  ANNUAL: 'Annual',
  description: 'Description',
  closedDates: 'Closed Dates',
  addClosedDate: 'Add Closed Date',
  addedClosedDate: 'Closed date added.',
  deletedClosedDate: 'Closed date deleted.',
  closedDateDelete: 'Closed date will be delete.',
  closeDateDeleted: 'Closed date deleted.',
  extraVesting: 'Extra Vesting',
  calculatingType: 'Calculating Type',
  gradualNormal: 'Gradual / Normal',
  addRule: 'Add Rule',
  specialProduct: 'Special Product',
  productID: 'Product ID',
  addToProduct: 'Add To Product',
  SINGLE_ORDER: 'SINGLE ORDER',
  ALL_ORDERS: 'ALL ORDERS',
  SINGLE_PRODUCT: 'SINGLE PRODUCT',
  minWorkTime: 'Min. Working Hours',
  advanceDayActiveControl: 'Advance Day Activity Control',
  advance: 'Advance',
  advanceFrequency: 'Advance Frequency',
  advanceTime: 'Advance Time',
  advancePrice: 'Advance Price',
  advanceRule: 'Advance Rule',
  storeGroups: 'Store Groups',
  slotCapacityImport: 'Slot Capacity Import',
  infoForSlotCapacityImport:
    'To upload data in the correct format, please review the Description page in the sample template.',
  infoForSlotCapacityImport1:
    'After uploading the relevant file, your records may not be processed into the system immediately. It can be monitored from a different screen regarding the status of the transaction or whether the data in the file gives an error.',
  fileTransferStarted: 'File transfer has been started.',
  boxShelfInfo: 'Box/Shelf',
  changeStatus: 'Change Status',
  orderStatusChanged: 'Order Status Changed',
  doYouConfirmChangeOrderStatus:
    'Selected Order will be {{statusTranslate}} , do you confirm?',
  CITY: 'CITY',
  REGION: 'REGION',
  editedProgressPaymentTemplate: 'Progress Payment Template Edited',
  addedProgressPaymentTemplate: 'Progress Payment Template Added',
  youMustHaveAtLeast2Grades:
    'There Must Be At Least 2 Gradual Progress Increases!',
  progressPaymentStatus: 'Progress Payment Status',
  period: 'Period',
  advancePayment: 'Advance Payment',
  orderQuantity: 'Order Quantity',
  workHour: 'Work Hour',
  fixedProgressPaymentAmount: 'Fixed Progress Payment Amount',
  additionalProgressPaymentAmount: 'Additional Progress Payment Amount',
  template: 'Template',
  DRAFT: 'Draft',
  WAITING_FOR_INVOICE: 'Waiting For Invoice',
  WAITING_FOR_APPROVAL: 'Waiting For Approval',
  APPROVED: 'Approved',
  orderAmount: 'Order Amount',
  courierPhone: 'Courier Phone',
  overDistanceAmount: 'Over Distance Amount',
  overDistanceQuantity: 'Over Distance Quantity',
  overDeciAmount: 'Over Deci Amount',
  overDeciQuantity: 'Over Deci Quantity',
  specialProductQuantity: 'Special Product Quantity',
  specialProductAmount: 'Special Product Amount',
  totalOrder: 'Total Order',
  progressPaymentCourierDetail: 'Progress Payment Courier Detail',
  showDetails: 'Show Details',
  REJECTED: 'Rejected',
  bulkDefinitionTracing: 'Bulk Definition Tracing',
  IN_PROGRESS: 'In Progress',
  actionID: 'Action ID',
  loadingTime: 'Loading Time',
  uploadedBy: 'Uploaded By',
  numberOfSuccessfulRegistrations: 'Number of Successful Registrations',
  totalNumberOfRecords: 'Total Number of Records',
  file: 'File',
  success: 'Success',
  orderDateOfDelivery: 'Order Date Of Delivery',
  airDistance: 'Air Distance (m)',
  categoryCode: 'Category Code',
  categoryName: 'Category Name',
  pickingOrder: 'Picking Order',
  storeBasedSections: 'Store Based Sections',
  importBasedSectionModalMessage:
    'To bulk upload/update, you need to install Excel in the format shown in the example.',
  reqMin1AdvanceRule: 'Please add at least one advance rule.',
  importBulkStoreInfo: 'Import Bulk Store Info',
  importStoreInfoMessage:
    'To bulk upload, you need to upload Excel in the format shown in the example. If you want to make a bulk update, the store code field must be filled. If the store code is empty, editing will not be possible.',
  imporAllZoneUpdateInfo: 'Import All Zone Update Info',
  importAllZoneUpdateMessage1: 'To bulk upload, you need to upload Excel in the format shown in the example.',
  importAllZoneUpdateMessage2:'If you want to make a bulk update, the zone code field must be filled.',
  importAllZoneUpdateMessage3:'If the zone code is empty, editing will not be possible.',
  reqSlotTemplateOrZone: 'Please select slot template or zone!',
  slotTemplateZoneListPage: 'Slot Template Zone List Page',
  searchByZoneOrSlotTemplateOnly: 'Search by Zone or Template Only',
  enterAFewLettersForZoneSearch:
    'Enter the Zone you want to select with a few letters',
  enterAFewLettersForStoreSearch:
    'Enter the Store you want to select with a few letters',
  editAndDelete: 'Edit/Delete',
  nameSurname: 'Name Surname',
  slotNotFound: 'Slot not found!',
  slotName: 'Slot Name',
  goToSlots: 'Go To Slots',
  goToZones: 'Go To Zones',
  storeDailyStatus: 'Store Daily Status',
  capacityShouldBeGreaterThanCurrentOrderCount:
    'Capacity should be greater than current order count!',
  storeManagement: 'Store Management',
  orderTransfer: 'Order Transfer',
  targetStore: 'Target Store',
  transferOrder: 'Transfer Order',
  orderTransferred: 'Order Transferred.',
  enterValue: 'This field cannot be empty, enter a value!',
  enterValidTimeRange: 'Enter a valid time range!',
  changedSlotNotFound: 'No slots to edit were found.',
  addSlot: 'Add New Slot',
  collapseWarningMessage:
    'You will not do any operation, close the menu and continue the process!',
  branchNameAndCode: 'Branch Code-Name',
  authorizedPerson: 'Authorized Person',
  authorizedRole: 'Authorized Role',
  saveEdit: 'Save Edit',
  lastTransactionDate: 'Last Transaction Date',
  sellerSource: 'Seller Source',
  transactionType: 'Transaction Type',
  transactionSource: 'Transaction Source',
  transactionQuantity: 'Current Free Transaction Quantity',
  stockTransactionQuantity: 'Stock Transaction Quantity',
  currentQuantity: 'Current Quantity',
  currentFreeQuantity: 'Current Free Quantity',
  maxSelectedDateRangeSevenDays: 'Maximum selected date range is 7 days',
  reportLinkSentMailMessage:
    'The report link has been sent to your e-mail address.',
  ecomParameters: 'ECOM Parameters',
  activeProduct: 'Active Product',
  lastAndFirstUpdateProductDate: 'Last/First Update Product Date',
  countOfStockedProducts: 'Count of Stocked Products',
  stockUpdateDate: 'Stock Update Date',
  openForSale: 'Open For Sale',
  successOpenedForSale: 'Selected products opened for sale.',
  EACH: 'Each',
  transactionDate: 'Transaction Date',
  productUnitType: 'Product Unit Type',
  totalStockAmount: 'Total Stock Amount',
  sellableStockAmount: 'Sellable Stock Amount',
  goToStockTransactions: 'Go To Stock Transactions',
  INTEGRATION: 'Integration',
  STOCK_CREATED_OR_UPDATED_INTEGRATION: 'Stock Created or Updated',
  STOCK_CREATED_OR_UPDATED: 'Stock Created or Updated',
  FAILED: 'Failed',
  COLLECTION_COMPLETED: 'Collection Completed',
  ADDITIONAL_ORDER: 'Additional Order',
  CANCELLED_BY_COURIER: 'Cancelled By Courier',
  ORDER_SHIPMENT_TRANSFERRED: 'Order Shipment Transferred',
  ECOMMERCE: 'Ecommerce',
  MOBILIVA: 'Mobiliva',
  OBASE: 'Obase',
  OBASE_RESULT: 'Obase Result',
  operationCode: 'Operation Code',
  enterOrderNumOrObaseId: 'Enter Order No or Obase ID!',
  generateSlot: 'Generate Slot',
  selectSlotTemplate: 'Select Slot Template',
  slotsGenerated: 'Slots generated.',
  selectSlotTemplateForThisZone:
    'Select Slot Template to create a zone slot with code',
  activeRegionStoreSelection: 'Active Region/Store Selection',
  assignSlotsTargetZone: 'Assign the Slots of the Zone in the Target Store',
  zoneToUseSlots: 'Zone to Use Slots',
  generateSlotWithTemplate: 'Generate Slot With Template',
  moveCourier: 'Move Courier',
  areMoveCouriers: 'Move distributors?',
  zoneRegionMove: 'Zone Region Move',
  selectStoreMovingFrom: 'Select the store you will be moving from.',
  slotTemplate: 'Slot Template',
  zoneMoveCompleted: 'Zone move has been completed.',
  availableForBulkSale: 'Available For Bulk Sale',
  FIXED_PRICE: 'Fixed Price',
  PROGRESS_PAYMENT_RELATED: 'Up to the Progress Payment Amount',
  kmProgressPaymentAmount: 'KM Progress Payment Amount (TL)',
  desiProgressPaymentAmount: 'Desi Progress Payment Amount (TL)',
  confirmSelected: 'Confirm Selected',
  rejectSelected: 'Reject Selected',
  confirmSelectedMessage: 'Are you sure you want to confirm the selections?',
  rejectSelectedMessage: 'Are you sure you want to reject the selections?',
  canceledQuantity: 'Canceled Quantity',
  reasonForCancellation: 'Reason For Cancellation',
  cancelingPerson: 'Canceling Person',
  cancellationDate: 'Cancellation Date',
  suitableForPaymentAtDoor: "Is it suitable for payment at the door?",
  SOK_POSITIVE: "SOK-POSITIVE",
  SOK_ECOM: "SOK-NEW ECOM",
  authorizedStores: 'Authorized Stores :',
  forbiddenRolesForUserEditMessage:"Information about this role comes with the integration. You can only edit the user's password on this screen. Other fields are for informational purposes.",
  minGramGreaterThanMaxGram: 'Min Gram must be greater than the previous Max Gram!',
  maxGramMustBeGreaterThanMinGram: 'Max Grams Min Grams must be greater!',
  overWeightAmount: "KG Progress Payment Amount (TL)",
  overWeightQuantity: "KG Amount",
  missingNotificationDate: "Missing Notification Date",
  currentFreeQuantityAtCancellation: "Current Free Quantity at Cancellation",
  actualFreeQuantity: "Current Free Quantity",
  cancelledDate: "Cancellation Date",
  goToDetail: 'Detaya Git',
  isContainingFrozenProduct: "Is Containing Frozen Product",
  isAvailableExstraPayment: "Is Available Exstra Payment",
  alternativeProductSelection: "Alternative Product Selection",
  notRequested: "Not Requested",
  requested: "Requested",
  callMe: "Call Me",
  fromStore: "From Store",
  finalTotalPrice: "Final Total Price",
  paymentDetail: "Payment Detail",
  erpCode: "ERP Code",
  cityAndDistrict: "City-District",
  collectedQuantity: "Collected Quantity",
  orderItemQuantity: "Order Quantities",
  myProfile: "My Profile",
  clickToUpdatePassword: "Click to update your password",
  currentPassword: "Current Password",
  twoPasswordNotEqual: "The two passwords that you entered do not match!",
  updatedPasswordAgainLogin: "Your password has been changed to successful. You must log in again",
  searchAllUsers: "Search All Users",
  alternativeToWhat: "Alternative To What",
  newOrderQuantity: "New Order Quantity",
  monthly: "Monthly",
  daily: "Daily",
  generalPerformance: "General Performance",
  target: "Target",
  ON_TIME_AND_COMPLETE_COLLECTION: 'On Time and Complete Collection',
  COMPLETE_COLLECTION: 'Complete Collection',
  ON_TIME_COLLECTION: 'On Time Collection',
  ON_TIME_DELIVERY: 'On Time Delivery',
  OTIF: 'OTIF',
  CANCELLATION_AND_RETURN: 'Cancellation and Return',
  kpiWarningMessage: "Select a store to see KPI data!!! ",
  updateKpiDataMessage: "KPI verileri 5 dk aralığı ile güncellenmektedir.",
  dataLoading: "Data Loading...",
  DELAYED_COLLECTION_ON_TIME: 'Delayed Collection On Time',
  DELAYED_AND_WAITING_FOR_COLLECTION: 'Delayed and Waiting for Collection',
  DELAYED_BY_WAITING_FOR_COURIER: 'Delayed by Waiting for Courier',
  DELAYED_ON_COURIER: 'Delayed on Courier',
  DELAYED_DELIVERY_AND_WAITING_FOR_DELIVERY: 'Delayed Delivery and Waiting for Delivery',
  DELAYED_DELIVERY_FROM_STORE: 'Delayed Delivery from Store',
  DELAYED_APPROVAL: 'Delayed Approval',
  storeOperations: "Store Operations",
  courierOperations: "Courier Operations",
  amountFromExtra: "Fazla Toplamadan Kaynaklana Tutar (TL)",
  reportType: 'Report Type',
  actionType: 'Action Type',
  ordersPendingActionMessage: 'Please select the Store and Filter for the orders you want to list!!!',
  maxSelectedDateRangeOneDayOrSelectCity: "Maximum range can be two day unless city is selected",
  sendEmail: 'Send Email',
  showDescription: 'Show Description',
  reportsGenerateMessage: '{{reportTemplate}} Report Has Been Sent to Your Email Address',
  STAFF: 'STAFF',
  TRADESMAN: 'TRADESMAN',
  massNotification: "Mass Notification",
  addMassNotification: "Add Mass Notification",
  notificationMethod: "Notification Method",
  targetUsers: "Target Users",
  targetDate: "Target Date",
  notificationText: "Notification Text",
  notificationHeader: "Notification Header",
  addedNotification: 'Notification Added',
  notificationDate: 'Select Notification Date',
  INSTANT: 'Instant',
  PLANNED: 'Planned',
  ANNOUNCEMENT: "ANNOUNCEMENT",
  PUSH: "PUSH",
  resendNotification: 'Resend Notification',
  scheduledDate: 'Scheduled Date',
  SENT: 'SENT',
  COULD_NOT_SEND: 'COULD NOT SEND',
  maxLength250Character: 'Max 250 characters',
  sendSmsOptionTitle: 'Send SMS on New Order',
  transportationMethods: 'Sevkiyat Yöntemlerini Taşıma',
  shipmentMethodToMove: 'Shipment Method To Move',
  shippingMethodsDefine: 'Shipping Methods Define',
  selectTheShipmentMethod: 'Select the shipment methods',
  EXCEL_UPLOAD: 'EXCEL UPLOAD',
  bonus: 'Bonus',
  bonusType: 'BonusAndPenalty Type',
  CUSTOMER_SURVEY: 'Customer Survey',
  PER_ORDER: 'Based on Order',
  PER_RATING: 'Based on Rating',
  bonusAndPenalty: 'Bonus/Penalty',
  method: 'Method',
  isDuplicateCombination: 'The same Bonus/Penalty already exists. Select another Bonus/Penalty.',
  createdBeforeCombination: 'Bonus/Penalty created with all available options.',
  pleaseFillAllFields: 'Please fill in all fields.',
  penalty: 'Penalty',
  bonusAndPenaltyType: 'Bonus/Penalty Type',
  initial: 'New',
  reviewing: 'Reviewing',
  applicable: 'Applicable',
  notApplicable: 'Not Applicable',
  not_applicable: 'Not Applicable',
  closed: 'Closed',
  statusAndDescription: 'Status and Description',
  updatedCourierApplication: 'Courier Application Updated',
  minPoint: 'Min Point',
  maxPoint: 'Max Point',
  minMustBeGreaterThanLastMin: "Min Must Be Greater Than Previous Max",
  maxMustBeGreaterThanMin: "Max Value Must Be Greater Than Min Value",
  customerType: 'Customer Type',
  priority: 'Zone Priority',
  isDuplicateCombinationRuleSet: 'Same Rule Set already exists. Select another Rule Set.',
  createdBeforeCombinationRuleSet: 'Rule Set created with all available options.',
  ruleType: 'Rule Type',
  effect: 'Effect',
  coefficient: 'Coefficient',
  coefficientMustBeGreaterThanPrevious: 'Coefficient must be greater than previous one.',
  addStoreProgressPayment: 'Add Store Progress Payment',
  addCourierProgressPayment: 'Add Courier Progress Payment',
  addProgressPayment: 'Add Progress Payment',
  specialDayProgressPayment: 'Special Day Progress Payment',
  vestingPercentage: 'Vesting Percentage',
  addNewSpecialDay: 'Add New Special Day',
  rulePositive: 'Add Fee',
  ruleNegative: 'Remove Fee',
  ORDER_AVERAGE: 'Order Average',
  coefficientMultiplier: 'Coefficient Multiplier',
  conditions: 'Conditions',
  conditionType: 'Condition Type',
  STORE: 'STORE',
  templateType: 'Template Type',
  editStoreProgressPayment: 'Edit Store Progress Payment',
  addNewBonusPenalty: 'Add New Bonus/Penalty',
  defineRuleSet: 'Define Rule Set',
  storeProgressPaymentTracking: 'Store Progress Payment Tracking',
  courierProgressPaymentTracking: 'Courier Progress Payment Tracking',
  advancePaymentInvoiceStatus: 'Advance Payment Invoice Status',
  invoiceInformations: 'Advance Invoice Informations',
  NOT_PROCESSED: 'Not Processed',
  SUCCESS: 'Success',
  cancelledOrderSize: 'Cancelled Order Size',
  percentage: 'Percentage',
  storeProgressPaymentCourierDetail: 'Store Progress Payment Courier Detail',
  courierCoordinateTimeOfDelivery: "Courier's Coordinate at the Time of Delivery",
  legalTitle: 'Legal Title',
  vknErrMessage: 'VKN should be between 10-12 characters!',
  regularOrder: 'Regular Order',
  regularOrderPrice: 'Regular Order Price',
  changeOrder: 'Change Order',
  returnPickup: 'Return Pickup',
  changeOrderPrice: 'Change Order Price',
  returnPickupOrderPrice: 'Return Order Price',
  additionalExists: 'Exists',
  additionalNotExists: 'Not Exists',
  WAITING_APPROVAL: 'Waiting Approval',
  WAITING_FINANCE_APPROVAL: 'Waiting Finance Approval',
  DECLINED: 'Declined',
  LEFT: 'Left',
};
